// @flow
import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateApplicantProfile } from 'api/userDashboard';
import { dismissResumeDBLoggedOut } from 'utils/resumeDatabase';
import { updateCurrentUser } from '../redux/main/actions/currentUser';

const ResumeDatabaseResponseContainer = ({
  children
}: {
  children: ({ dismiss: Function }) => React.Node
}) => {
  const { currentUser } = useSelector(state => ({
    currentUser: state.currentUser
  }));
  const dispatch = useDispatch();

  const dismiss = () => {
    if (currentUser.id) {
      updateApplicantProfile({ isRecruitable: false }).then(() => {
        dispatch(
          updateCurrentUser({
            ...currentUser,
            isRecruitable: false
          })
        );
      });
    } else {
      dismissResumeDBLoggedOut();
      dispatch(
        updateCurrentUser({
          ...currentUser,
          isRecruitable: false
        })
      );
    }
  };

  return children({ dismiss });
};

export default ResumeDatabaseResponseContainer;
